import React, { Component } from 'react';
import { BlazeTableColDef, BlazeTableOptions } from 'components/blazeTable/BlazeTable.types';
import BlazeTable from 'components/blazeTable/BlazeTable';
import { ApplicationState } from 'store/rootReducer';
import './MarFileListPopover.css';
import { connect } from 'react-redux';
import { getLocValue } from 'utils/mockServiceUtils';
import { MarFile, ServiceMockMarDto } from '../../../../store/marFiles/marFilesTypes';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import SimpleLoader from '../../../../components/loaders/SimpleLoader';
import { toggleExpandedMockServiceRow } from '../../../../store/mockServices/mockServiceList/mockServiceListActions';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import i18n from '../../../../i18n';
import { ToastType } from '../../../../store/ui/toasts/toastsTypes';
import MixpanelService from '../../../../utils/mixpanelService';
import { COPY_ENDPOINT_MOCK_SERVICE } from '../../../../utils/mixpanelEvents';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import BzmIcon from '../../../../components/icons/BzmIcon';
import { DEFAULT_POPPER_CONFIG } from '../../../../constants/ui-constants';

interface MarFilesListProps {
  data: MarFile;
}

/**
 * MAR Files List Popover.
 **/
class MarFilesListPopover extends Component<AllProps> {
  NameCell = (rowData: ServiceMockMarDto) => {
    return (
      <div>
        <span id={`mockServiceLocationValue` + rowData.id}>
          <Link to={`/mock-services/${rowData.id}`}>{rowData.name}</Link>
        </span>
      </div>
    );
  };

  LocationCell = (rowData: ServiceMockMarDto) => {
    return (
      <div>
        <span id={`mockServiceLocationValue` + rowData.id}>
          {getLocValue(rowData.harborId, rowData.shipId, this.props.locations)}
        </span>
      </div>
    );
  };

  StatusCell = (rowData: ServiceMockMarDto) => {
    if (rowData.status === 'CONFIGURING') {
      return (
        <span id={`mockServiceStatusValue` + rowData.id}>
          <SimpleLoader loadingText={i18n.t('common:simpleLoader.pleaseWait')} />
        </span>
      );
    }

    if (rowData.status === 'FAILED') {
      return (
        <div id={`mockServiceStatus` + rowData.id}>
          <span className="status status-labeled status-error">
            <span className="status-indicator" />
            <span id={`mockServiceStatusValue` + rowData.id} className="status-label" title={rowData.status}>
              {i18n.t('marFiles:marPopover.failed')}
            </span>
          </span>
        </div>
      );
    }

    if (rowData.status === 'STOPPED') {
      return (
        <div id={`mockServiceStatus` + rowData.id}>
          <span className="status status-labeled status-stop">
            <span className="status-indicator" />
            <span id={`mockServiceStatusValue` + rowData.id} className="status-label" title={rowData.status}>
              {i18n.t('marFiles:marPopover.stopped')}
            </span>
          </span>
        </div>
      );
    }

    if (rowData.status === 'RUNNING') {
      return (
        <div>
          <span className="status status-labeled status-run">
            <span className="status-indicator" />
            <span id={`mockServiceStatusValue` + rowData.id} className="status-label" title={rowData.status}>
              {i18n.t('marFiles:marPopover.running')}
            </span>
          </span>
        </div>
      );
    }
    return <span>-</span>;
  };

  copyEndpointToClipboard = (endpointText: string) => {
    try {
      const el = document.createElement('textarea');
      el.value = endpointText;
      el.setAttribute('readonly', '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.props.showToastNotification(ToastType.Success, i18n.t('mockServices:successMsgs.copyEndpointSuccessMsg'));
      MixpanelService.track(COPY_ENDPOINT_MOCK_SERVICE(), true);
    } catch (e) {
      this.props.showToastNotification(
        ToastType.Danger,
        i18n.t('mockServices:ErrorMsgs.networkProblem'),
        i18n.t('mockServices:ErrorMsgs.failedToCopyEndpoint'),
      );
    }
  };

  CopyEndpoint = (rowData: ServiceMockMarDto) => {
    if (rowData.status === 'RUNNING' || (rowData.status === 'STOPPED' && rowData.svEndpoint != null)) {
      return (
        <div className="flex-table-actions ml-3">
          <button
            className="btn btn-link-dark btn-no-hover"
            title={i18n.t('mockServices:mockServicesTable.copyMockServiceEndpoint')}
            id={`mockServiceEndpointCopyButton` + rowData.id}
            onClick={() => this.copyEndpointToClipboard(rowData.svEndpoint)}
          >
            <BzmIcon variant={'icon-bzm-copy'} className={'icon-xs'}></BzmIcon>
          </button>
        </div>
      );
    }
  };

  EndpointCell = (rowData: ServiceMockMarDto) => {
    let endpoint = '';

    if (rowData.status === 'RUNNING' || rowData.status === 'STOPPED') {
      endpoint = rowData.svEndpoint;
    }

    return (
      <div id={`mockServiceEndpointValue` + rowData.id} title={endpoint}>
        {endpoint}
        {this.CopyEndpoint(rowData)}
      </div>
    );
  };

  popoverColsDefinition: BlazeTableColDef[] = [
    {
      header: 'Virtual Service',
      cellComponent: (rowData: any) => this.NameCell(rowData),
      width: 200,
      accessor: '',
    },
    {
      header: 'Location',
      width: 160,
      cellComponent: (rowData: any) => this.LocationCell(rowData),
      accessor: '',
    },
    {
      header: 'Endpoint',
      width: 200,
      cellComponent: (rowData: any) => this.EndpointCell(rowData),
      accessor: 'endpoint',
    },
    {
      header: 'Status',
      width: 120,
      cellComponent: (rowData: ServiceMockMarDto) => this.StatusCell(rowData),
      accessor: 'status',
    },
  ];

  popoverTableOptions: BlazeTableOptions = {
    showRowExpander: false,
    columnDef: this.popoverColsDefinition,
    pageable: true,
    selectable: false,
    pageSize: 10,
    minWidth: 750,
    minHeight: 100,
    tableName: 'popoverList',
    noResultsText: 'No Deployments available',
    customTableClassName: 'flex-table-simple flex-table-condensed',
  };

  getPopoverRows = (rowData: MarFile) => {
    return (
      <React.Fragment>
        <div>
          <BlazeTable options={this.popoverTableOptions} data={rowData.serviceMockMarDtos} />
        </div>
      </React.Fragment>
    );
  };

  popover = (rowData: MarFile) => {
    return (
      <div>
        <Popover id="marPopover" className="marPopover" placement={'bottom'}>
          <div>{this.getPopoverRows(rowData)}</div>
        </Popover>
      </div>
    );
  };

  DeployedCountComponent = (rowData: MarFile) => {
    let totalCount = 0;
    let runningCount = 0;

    if (rowData.serviceMockMarDtos != null) {
      totalCount = rowData.serviceMockMarDtos.length;
    }

    if (totalCount === 0) {
      return (
        <div className={'status'}>
          <span id={`mockServiceStatusValue` + rowData.id} className="status-label marCount">
            -
          </span>
        </div>
      );
    }

    for (const serviceMockMarDto of rowData.serviceMockMarDtos) {
      if (serviceMockMarDto.status === 'RUNNING') {
        runningCount++;
      }
    }

    if (runningCount === 0) {
      return (
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={this.popover(rowData)}
          rootClose={true}
          popperConfig={DEFAULT_POPPER_CONFIG}
        >
          <div className="statusPointer">
            <span className={'status'}>
              <span id={`mockServiceStatusValue` + rowData.id} className="status-label marCountWithSuccess">
                {totalCount.toString()}
              </span>
            </span>
          </div>
        </OverlayTrigger>
      );
    }

    return (
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        overlay={this.popover(rowData)}
        rootClose={true}
        popperConfig={DEFAULT_POPPER_CONFIG}
      >
        <div className="statusPointer">
          <span className="status status-labeled status-run">
            <span id={`mockServiceStatusValue` + rowData.id} className="status-label marStatusSuccess">
              {i18n.t('marFiles:marPopover.running')} {runningCount}
            </span>
          </span>

          <span className="status status-labeled">
            <span id={`mockServiceStatusValue` + rowData.id} className="status-label marCountWithSuccess">
              {i18n.t('marFiles:marPopover.of')} {totalCount}
            </span>
          </span>
        </div>
      </OverlayTrigger>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div>{this.DeployedCountComponent(this.props.data)}</div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ mockservices, blazeUserConfig }: ApplicationState) => {
  return {
    locations: mockservices.locData,
    blazeUserConfig: blazeUserConfig.blazeUserConfig,
  };
};

const mapDispatchToProps = {
  toggleExpandedMockServiceRow,
  showToastNotification,
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = typeof mapDispatchToProps;
type AllProps = MapStateToProps & MapDispatchToProps & MarFilesListProps & RouteComponentProps<any>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarFilesListPopover));
